import axios from "axios";
import React, {useEffect, useRef, useState} from "react";
import {useParams} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function LabResultEntry(props) {
    const {appt_id, ltestid} = useParams();
    const [selectedDateTime, setSelectedDateTime] = useState(new Date());
    const [labData, setlabData] = useState([]);
    const [labbillData, setLabBillData] = useState([]);
    const [labTatData, setLabTatData] = useState([]);
    const [text, setText] = useState('');
    const [patData, setPat] = useState('');
    const [age, setAge] = useState('');
    const [gender, setGender] = useState('');
    const [rqty, setrqty] = useState('');
    const [id, setid] = useState('');
    const quillRef = useRef(null);
    const [resultFormData, setResultFormData] = useState({
        "pat": '',
        "cons": '',
        "lab_id": '',
        "ltest_id": '',
        "patient": '',
        "age": '',
        "gender": '',
        "sample_date": '',
        "lab_test": '',
        "results": '',
        "abnormal_status": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
    });
    const handleChange = (event) => {
        const inputName = event.target.name;
        const inputValue = event.target.value;
        if (inputName === 'patient') {
            setPat(inputValue);
        } else if (inputName === 'age') {
            setAge(inputValue);
        } else if (inputName === 'gender') {
            setGender(inputValue);
        }
    };
    const inputHandler = (eventOrValue) => {
        if (eventOrValue.target) {
            setResultFormData({
                ...resultFormData,
                [`abValue_${eventOrValue.target.id.split('_')[1]}`]: eventOrValue.target.checked,
            });
        } else {
            setResultFormData({
                ...resultFormData,
                result: eventOrValue,
            });
        }
    };
    useEffect(() => {
        try {
            axios.get(baseUrl + 'lab-test-view/' + ltestid + '/')
                .then(function (response) {
                    setLabBillData(response.data);
                });
        } catch (error) {
            console.log(error);
        }
        try {
            axios.get(baseUrl + 'lab-pay/' + appt_id)
                .then(function (response3) {
                    setlabData(response3.data);
                    setPat(response3.data[0].pat.patient);
                    setAge(response3.data[0].pat.age);
                    setGender(response3.data[0].pat.gender);
                    const labid = response3.data[0]?.id;
                    axios.get(`${baseUrl}check-sample/${labid}/${ltestid}`)
                        .then(response4 => {
                            setLabTatData(response4.data)
                        })
                        .catch(error => console.error("Error checking sample IDs:", error));
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    useEffect(() => {
        const textarea = document.querySelector('textarea.no-comma');
        if (!textarea) {
            return;
        }
        function handleKeyDown(e) {
            if (e.keyCode === 188 || e.keyCode === 222) {
                e.preventDefault();
            }
        }
        function handleChangeInput() {
            textarea.value = textarea.value.replace(/,/g, '');
        }
        textarea.addEventListener('keydown', handleKeyDown);
        textarea.addEventListener('change', handleChangeInput);
        textarea.addEventListener('input', handleChangeInput);
        return () => {
            textarea.removeEventListener('keydown', handleKeyDown);
            textarea.removeEventListener('change', handleChangeInput);
            textarea.removeEventListener('input', handleChangeInput);
        };
        function handleKeyPress(e) {
            const ignoreKeyCodes = [34, 39];
            if (ignoreKeyCodes.includes(e.which)) {
                e.preventDefault();
                document.querySelector('.error').innerHTML = 'only valid characters are allowed';
                document.querySelector('.error').style.display = 'block';
            } else {
                document.querySelector('.error').style.display = 'none';
            }
        }
        document.addEventListener('keypress', handleKeyPress);
        return () => {
            document.removeEventListener('keypress', handleKeyPress);
        };
    }, []);
    const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.target;
        let results = '';
        let abValueString = '';
        const formData = new FormData();
        const pat_id = document.getElementById("pat_id").value;
        const cons_id = document.getElementById("cons_id").value;
        const patient = document.getElementById("patient").value;
        const age = document.getElementById("age").value;
        const gender = document.getElementById("gender").value;
        const sampleDate = document.getElementById("sampleDate").value;
        const test = document.getElementById("test").value;
        for (let i = 0; i < labbillData.length; i++) {
            const abValue = resultFormData[`abValue_${i}`] ? "1" : "0";
            abValueString += abValue + ',';
        }
        abValueString = abValueString.slice(0, -1);
        const textareaList = document.querySelectorAll('textarea.no-comma');
        textareaList.forEach(textarea => {
            results += textarea.value + ',';
        });
        results = results.slice(0, -1);
        formData.append('pat', pat_id);
        formData.append('cons', cons_id);
        formData.append('lab_id', appt_id);
        formData.append('appt_id', appt_id);
        formData.append('ltest_id', ltestid);
        formData.append('patient', patient);
        formData.append('age', age);
        formData.append('gender', gender);
        formData.append('sample_date', sampleDate);
        formData.append('lab_test', test);
        formData.append("results", results);
        formData.append('abnormal_status', abValueString);
        formData.append('status', '1');
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
        formData.append('location', userLocation);
        axios.post(`${baseUrl}pat-update/${pat_id}/`, formData, {
            headers: {
                'content-type': 'multiple/form-data'
            }
        })
            .then(response => {
                if (response.status == 200 || response.status == 201) {
                }
            })
            .catch((error) => {
                console.error("Error updating patient data:", error);
            });
        axios.post(`${baseUrl}lab-op-create/`, formData, {
            headers: {
                'content-type': 'multiple/form-data'
            }
        })
            .then(response => {
                if (response.status == 200 || response.status == 201) {
                    const eqpData = {
                        id: id,
                        totqty: rqty,
                        location: userLocation,
                        status: 1,
                        addedby: userName,
                        ip_add: ipAddress,
                    };
                    Swal.fire({
                        title: 'Lab entry has been added.',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    setResultFormData({
                        pat: '',
                        cons: '',
                        lab_id: '',
                        ltest_id: '',
                        patient: '',
                        age: '',
                        gender: '',
                        sample_date: '',
                        lab_test: '',
                        results: '',
                        abnormal_status: '',
                        status: '',
                        addedby: '',
                        ip_add: '',
                    });
                    setTimeout(() => {
                        window.location.href = ('/lab-result-view/');
                    }, 2000);
                }
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed to add lab entry. Please try again later.',
                    'error'
                );
            });
    };
    const handleLoad = (quill) => {
        quillRef.current = quill;
    };
    return (
        <section>
            <form>
                <div>
                    {labData.map((row, index) =>
                        <div className="table-responsive">
                            <table className="erp-table-modern">
                                <tr style={{backgroundColor: "#1bc5ce", color: "white"}}>
                                    <th colSpan="2" className="patient-header">

                                        <input type="hidden" name="pat_id" id="pat_id" value={row.pat.id}/>
                                        <input type="hidden" name="cons_id" id="cons_id" value={row.cons.id}/>

                                        <div className="patient-info-grid">

                                            <div className="info-item">
                                                <label>Patient Name</label>
                                                <input
                                                    type="text"
                                                    name="patient"
                                                    id="patient"
                                                    value={patData}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                />
                                            </div>

                                            <div className="info-item">
                                                <label>Patient ID</label>
                                                <span>{row.pat.pat_id}</span>
                                            </div>


                                            <div className="info-item">
                                                <label>Gender</label>
                                                <input
                                                    type="text"
                                                    name="gender"
                                                    id="gender"
                                                    value={gender}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                />
                                            </div>

                                            <div className="info-item">
                                                <label>Age</label>
                                                <input
                                                    type="text"
                                                    name="age"
                                                    id="age"
                                                    value={age}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                />
                                            </div>

                                            <div className="info-item">
                                                <label>Sample Date & Time</label>
                                                <DatePicker
                                                    name="sampleDate"
                                                    id="sampleDate"
                                                    selected={selectedDateTime}
                                                    onChange={handleDateTimeChange}
                                                    dateFormat="yyyy-MM-dd h:mm aa"
                                                    showTimeSelect
                                                    timeIntervals={15}
                                                    timeCaption="Time"
                                                    className="form-control"
                                                />
                                            </div>
                                            <div className="info-item">
                                                <label>Consultant</label>
                                                <span>Dr. {row.cons.consultant}</span>
                                            </div>

                                        </div>
                                    </th>
                                </tr>
                            </table>
                        </div>
                    )}
                    <div className="table-responsive">
                        <table className="erp-table-modern">
                            <thead>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <th align="left">Sample Type</th>
                                <th align="left">Test</th>
                                <th align="left">Results</th>
                                <th align="left">Abnormal</th>
                                <th align="left">Units</th>
                                <th align="left">Ranges</th>
                                <th align="left">Method</th>
                                <th align="left">TAT</th>
                            </tr>
                            </thead>
                            <tbody>
                            {labbillData.map((lab, index) =>
                                    <tr key={`${index}`}>
                                        <td style={{border: "1px solid", borderColor: "#2194d9"}}>{lab.sample}</td>
                                        <input type="hidden" name="test" id="test" value={lab.subcat.subcat}/>
                                        <td style={{border: "1px solid", borderColor: "#2194d9"}}>{lab.test}</td>
                                        <td style={{border: "1px solid", borderColor: "#2194d9"}}>
                                            {ltestid === '51' ? (
                                                <ReactQuill
                                                    style={{height: "200px"}}
                                                    className="my-quill"
                                                    tabIndex="0"
                                                    onLoad={handleLoad}
                                                    name="result[]"
                                                    id="result"
                                                    value={resultFormData.result}
                                                    onChange={(value) => inputHandler(value)}
                                                    modules={{
                                                        toolbar: [
                                                            [{header: [1, 2, false]}],
                                                            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                            [
                                                                {list: 'ordered'},
                                                                {list: 'bullet'},
                                                                {indent: '-1'},
                                                                {indent: '+1'},
                                                            ],
                                                            ['link', 'image'],
                                                            ['clean'],
                                                        ],
                                                    }}
                                                />
                                            ) : (
                                                <textarea className="no-comma" tabIndex="0" name="result[]" id="result"
                                                          value={resultFormData.result} onChange={inputHandler} required>
                           </textarea>
                                            )}
                                        </td>
                                        <td style={{border: "1px solid", borderColor: "#2194d9"}}>
                                            <input className="form-check-input" tabIndex="-1" type="checkbox"
                                                   name="abValue[]"
                                                   id={`abValue_${index}`} onChange={inputHandler}
                                                   value={resultFormData[`abValue_${index}`] ? "1" : "0"}/>
                                        </td>
                                        <td style={{border: "1px solid", borderColor: "#2194d9"}}>{lab.units}</td>
                                        <td style={{border: "1px solid", borderColor: "#2194d9"}}>{lab.ranges}</td>
                                        <td style={{border: "1px solid", borderColor: "#2194d9"}}>{lab.method}</td>
                                        <td>
                                            <button
                                                type="button"
                                                className="btn btn-warning"
                                                data-bs-toggle="modal"
                                                data-bs-target="#refund-ip-modal"
                                                tabIndex="-1"
                                            >
                                                TAT
                                            </button>
                                        </td>
                                    </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="modal fade" id="refund-ip-modal" tabIndex="-1" aria-labelledby="refund-ip-modal-label"
                     aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="tat-modal-label">TAT Report</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"
                                        aria-label="Close"></button>
                            </div>
                            <div className="modal-body overflow-auto" style={{maxHeight: "175vh"}}>
                                <table className="erp-table-modern">
                                    <thead>
                                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                        <th>Patient</th>
                                        <th>Work Order</th>
                                        <th>Sample ID</th>
                                        <th>Accept By</th>
                                        <th>Accept Date</th>
                                        <th>Collect By</th>
                                        <th>Collect Date</th>

                                    </tr>
                                    </thead>
                                    <tbody>
                                    {labTatData.map((item) => (
                                        <tr key={item.id}>
                                            <td>{item.lab.pat.patient}</td>
                                            <td>{item.workorder}</td>
                                            <td>{item.sampleid}</td>
                                            <td>{item.acceptby}</td>
                                            <td>{item.accept_date}</td>
                                            <td>{item.collectby}</td>
                                            <td>{item.collect_date}</td>

                                        </tr>
                                    ))}
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>
                </div>
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <button type="button" onClick={handleSubmit} className="btn btn-primary mt-4">
                        Submit
                    </button>
                </div>
            </form>
        </section>
    );
}
export default LabResultEntry;
